import { Box, Flex, Text } from './styles';
import HeaderCover from './HeaderCover';
import HtmlParser from './HtmlParser';
import Avatar from './styles/Avatar';
import { Person } from './apiService';
import styled from '@emotion/styled';
import { headerHeight } from './Header';
import Dialog from './Dialog';
import { useState } from 'react';
import { sanitize } from './utils';
import { globalPadding } from './Layout/Layout';

const Content = styled(Box)();

export default function ArtistHeader({
  cover_image,
  summary,
  ...rest
}: Person) {
  const [showModal, setShowModal] = useState(false);

  if (!summary) return (
    <Content
      mt={headerHeight}
      px={globalPadding}
      pt={{ xs: 5, sm: 0 }}
      className="header-cover"
    >
      <AvatarName {...rest} />
    </Content>
  );

  const { truncated, full, hasMore } = sanitize({ raw: summary || '', limit: 500 });

  return (
    <HeaderCover image={cover_image?.path}>
      <AvatarName {...rest} />
      {summary && (
        <>
          <SummaryWrapper>
            <HtmlParser data={truncated} hasMore={hasMore} onShowMore={() => setShowModal(true)} />
          </SummaryWrapper>
          {hasMore && (
            <Dialog open={showModal} onClose={() => setShowModal(false)}>
              <HtmlParser data={full} />
            </Dialog>
          )}
        </>
      )}
    </HeaderCover>
  );
}

const AvatarName = ({ avatar_image, name, name_en }: Person) => (
  <Flex
    direction={{ xs: 'column', sm: 'row' }}
    align="center"
    mt={{ xs: '-1rem', sm: 3 }}
    mb={2}
  >
    <Avatar
      size="6.25rem"
      alt={`${name} | ${name_en}`}
      image={avatar_image?.path}
      placeholder="/static/images/placeholder/star.svg"
      ml={{ sm: 2 }}
    />
    <Flex mt={1} direction="column" align={{ xs: 'center', sm: 'flex-start' }}>
      <Text variant="h1">{name}</Text>
      <Text variant="h2" color="weak">{name_en}</Text>
    </Flex>
  </Flex>
);

const SummaryWrapper = styled.div(({ theme }) => ({
  maxWidth: '32rem',
  ...theme.font.responsiveSize(2),
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    order: 1,
    marginBottom: theme.spacing(8),
  },
}));
